const es = {
	service: {
		required: {
			description: 'Este servicio es necesario siempre',
			title: '(siempre requerido)',
		},
		disableAll: {
			description: 'Utilice este interruptor para activar o desactivar todos los servicios.',
			title: 'Activar o desactivar todos los servicios',
		},
		purpose: 'Finalidad',
		purposes: 'Finalidades',
	},
	consentModal: {
		description:
			'Aquí puedes evaluar y personalizar los servicios que nos gustaría utilizar en este sitio web. Habilita o deshabilita los servicios como consideres oportuno.',
		privacyPolicy: {
			name: 'política de cookies',
		},
		title: 'Configuración de cookies',
	},
	consentNotice: {
		changeDescription: 'Ha habido cambios en las cookies desde su última visita. Debe renovar su consentimiento.',
		description:
			'Utilizamos cookies propias y de terceros para <b>Analíticas & Marketing</b>. Haz clic en botón <b>Aceptar</b> si deseas admitir todas las cookies, o haga clic en el texto <b>Quiero elegir...</b> para admitir sólo las cookies que desees o rechazarlas todas (excepto las funcionales, que son necesarias). Podrás modificar la configuración de cookies en cualquier momento en la página política de cookies en el botón <b>Modificar mi configuración de cookies en el portal</b>.',
		privacyPolicy: {
			name: 'política de cookies',
		},
		learnMore: 'Quiero elegir...',
	},
	purposes: {
		functional: {
			title: 'Funcionales',
			description:
				'Estos servicios son esenciales para el correcto funcionamiento de este sitio web. No puede desactivarlos ya que la página no funcionaría correctamente.',
		},
		analytics: {
			title: 'Analíticas',
			description:
				'Estos servicios nos permiten realizar un seguimiento y análisis de las visitas que recibe la web.',
		},
		marketing: {
			title: 'Marketing',
			description:
				'Estos servicios procesan información personal para mostrarle contenido relevante sobre productos, servicios o temas que puedan interesarle.',
		},
	},
	privacyPolicy: {
		name: 'política de cookies',
		text: 'Para saber más, por favor lea nuestra {privacyPolicy}, podrás modificar la configuración de las cookies en cualquier momento en el botón <b>Modificar mi configuración de cookies</b>.',
	},
	purposeItem: {
		service: 'servicio',
		services: 'servicios',
	},
	ok: 'Aceptar',
	save: 'Guardar',
	decline: 'Descartar todas',
	acceptSelected: 'Aceptar seleccionadas',
	acceptAll: 'Aceptar todas',
	poweredBy: '',
};

export default es;
